module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/room-1328a4fd48ba9b10d3619ae3a19f7f47.webp";